<template>
  <div v-if="bidCreatedModal.lot.currency" class="ta-bid-created-modal-data ta-bid-created-modal-your-bid">
    <div class="ta-data-label">
      {{ $t('Your Bid')}}
    </div>
    <div class="ta-data-value">
      {{bidCreatedModal.bid.amount | asCurrency(bidCreatedModal.lot.currency.code)}}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "YourBid",
  computed: {
    ...mapState(['bidCreatedModal']),
  }
}
</script>

<style lang="scss" scoped>
</style>
